import { setConfigStateById } from '../ConfigContext';

export const setCurrentLayout = (setState: setConfigStateById) => (layout) => {
  setState('SET_CURRENT_LAYOUT', (s) => ({
    ...s,
    currentLayout: layout,
  }));
};
